import axios from "axios";

const baseURL =
  "https://kortexautomations.com/api" ||
  // "https://kortex-server.vercel.app/api" ||
  // process.env.REACT_APP_API_URL ||
  "http://localhost:5000/api";

const client = axios.create({ baseURL });

// Attach admin token when present.
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("kortex_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;
